/**
 * Signed millimetre offset, with a typographic minus. Shared so the slider's
 * end labels and the adjusted-result subtitle read identically.
 */
export const formatOffsetMm = (value: number): string =>
  `${value < 0 ? '−' : '+'}${Math.abs(value).toFixed(1)}`
